import { render, staticRenderFns } from "./Recharge.vue?vue&type=template&id=67c3d848&scoped=true"
import script from "./Recharge.vue?vue&type=script&lang=js"
export * from "./Recharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c3d848",
  null
  
)

export default component.exports